import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import {
  TextField,
  InputAdornment,
  IconButton,
  ClickAwayListener,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import queryString from "query-string";
import { CoinContext } from "../../contexts/CoinContext";
import { useHistory, Link } from "react-router-dom";
import loaderGif from "../../assets/img/loader.gif";
import ReCAPTCHA from "react-google-recaptcha";
// import indFlag from "../../assets/img/india-flag-icon.png";
import "../flag.css";
import { REACT_APP_PROD_URL, SITE_KEY_CAPTCHA } from "../../services/configs";
import { useDispatch, useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import useResizer from "./../../services/useResizer";
import AppSVG from "../../assets/signInPageSlideImages/qrcode.svg";
import GooglePlay from "../../assets/svgs/google-play.svg";
import { isMobile } from "react-device-detect";
import Checkbox from "@material-ui/core/Checkbox";
import PasswordEye from "../../assets/svgs/password-eye.svg";
import UserIcon from "../../assets/svgs/user-icon.svg";

import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.scss"; // core Swiper
import "swiper/modules/navigation/navigation.scss"; // Navigation module
import "swiper/modules/pagination/pagination.scss"; // Pagination module

SwiperCore.use([Pagination, Navigation, Autoplay]);

export default function Signup(props) {
  const ref = useRef();

  const settings = {
    slidesPerView: 0,
    preloadImages: true,
    freeMode: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
    direction: "horizontal",
    speed: 3000,
    initialSlide: 0,
    allowTouchMove: true,
    watchOverflow: true,
  };

  const isMobile = useResizer();
  const images = [
    { url: "../../assets/signInPageSlideImages/two.svg" },
    { url: "../../assets/signInPageSlideImages/three.svg" },
  ];
  const classes = useStyles();
  const history = useHistory();
  let theme = useTheme();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.trading.TOKEN);
  const referral = useSelector((state) => state.trading.REFERRAL);

  if (token) {
    history.push("/trade/BTC");
  }
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  // const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [repassword, setRepassword] = useState(null);
  const [refCode, setRefCode] = useState(() =>
    Boolean(referral) ? referral : "",
  );
  const [signedup, setSignedup] = useState(false);
  const [otp, setOtp] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [validForm, setValidForm] = useState(true);

  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [terms, setTerms] = useState(true);

  const [errorFields, setErrorFields] = useState({
    email: false,
    pass: false,
    repass: false,
    otp: false,
    failed: false,
  });

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  const [captcha, setCaptcha] = useState("");
  const reRef = useRef();

  const [referralBox, setReferalBox] = useState(false);

  useEffect(() => {
    let val = queryString.parse(props.location.search);
    if (val.emailid) {
      setEmail(val.emailid);
    }
  }, []);
  useEffect(() => {
    if (Boolean(referral)) {
      setRefCode(referral);
      setReferalBox(true);
    }
  }, [referral]);
  function detectIfFreshchatHasLoaded() {
    if (document.querySelector("#fc_frame, #fc_frame.fc-widget-normal")) {
      return true;
    } else {
      return false;
    }
  }
  const { handleClickAlert } = useContext(CoinContext);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    if (errorFields.failed) {
      setErrorFields({
        ...errorFields,
        failed: true,
      });
    } else {
      history.push(`/login`);
    }
  };

  async function submitForm() {
    if (signedup) {
      if (email && otp) {
        setLoading(true);
        // console.log("Verifying phone number");
        fetcher(`/verifyEmail`, {
          method: "POST",
          body: {
            email: email,
            otp: otp,
            clientKey: captcha,
          },
        })
          .then((res) => {
            dispatch({ type: "SET_TOKEN", payload: res.id_token });
            dispatch({ type: "SET_LOGIN_ID", payload: res.loginId });
            // console.log(res);
            setSignedup(true);
            setLoading(false);
            handleDialogOpen();

            // console.log(res);
          })
          .catch((err) => {
            setSignedup(false);
            setErrorFields({
              email: false,
              pass: false,
              repass: false,
              otp: false,
              failed: true,
            });
            setLoading(false);
            handleDialogOpen();
            // console.log(err)
          });
      } else {
        setErrorFields({
          ...errorFields,
          otp: true,
        });
      }
    } else {
      if (
        email &&
        !errorFields.email &&
        !errorFields.pass &&
        !errorFields.repass &&
        password &&
        repassword &&
        terms
      ) {
        const captchaToken = await reRef.current.executeAsync();
        setCaptcha(captchaToken);
        reRef.current.reset();

        setLoading(true);
        fetcher(`/register`, {
          method: "POST",

          body: {
            email: email,
            password: password,
            referralCode: refCode,
            clientKey: captchaToken,
          },
        })
          .then((res) => {
            setStartTimer(true);
            setSignedup(true);
            setValidForm(true);
            setLoading(false);

            // console.log(res);
          })
          .catch((err) => {
            if (err.status === 409) {
              handleClickAlert("error", "Email already in use!");
              setValidForm(false);
            } else if (err.status === 400) {
              handleClickAlert("error", "Invalid referral code!");
            } else {
              handleClickAlert("error", "Registration failed!");
            }
            // setValidForm(false);
            setLoading(false);
            // console.log(err)
          });
      } else {
        setErrorFields({
          ...errorFields,
          email: email ? errorFields.email : true,
          pass: password ? errorFields.pass : true,
          repass: repassword ? errorFields.repass : true,
        });
      }
    }
  }

  function resendOtp() {
    if (email) {
      // setStartTimer(true);
      fetcher(`/resendOtp?login=${email}&type=register`)
        .then((res) => {
          // setSignedup(true);
          setStartTimer(true);
          handleClickAlert("success", "OTP resent");

          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "OTP resend failed");
          // console.log(err)
        });
    } else {
      handleClickAlert("error", "OTP resend failed");
    }
  }

  function getPassword(str) {
    setPassword(str);

    // var checkSpecial = /[*@!#%&()^~{}]+/.test(str);
    // var checkUpper = /[A-Z]+/.test(str);
    // var checkLower = /[a-z]+/.test(str);

    // if (checkSpecial && checkUpper && checkLower) {
    //   setValidPassword(true);
    // } else {
    //   setValidPassword(false);
    // }
  }

  // function retypePass(str) {
  //   if (str === password) {
  //     setValidRepass(true);
  //   } else {
  //     setValidRepass(false);
  //   }
  // }

  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);

  return (
    <div
      className={
        !isMobile ? classes.mainContainer : classes.mainContainerMobile
      }
    >
      <Container
        className={classes.root}
        component="main"
        maxWidth="xs"
        style={{
          background: "#1C212A",
          borderRadius: !isMobile ? "30px" : "15px",
          paddingTop: !isMobile ? "24px" : "16px",
          paddingBottom: !isMobile ? "24px" : "16px",
          paddingLeft: !isMobile ? "24px" : "16px",
          paddingRight: !isMobile ? "24px" : "16px",
          minHeight: isMobile ? "0vh" : "65vh",
          width: "95%",
        }}
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Typography variant="h4" className={classes.title}>
            Create Your account
          </Typography>

          <p
            className={classes.question}
            style={isMobile ? { marginTop: "2px" } : { marginTop: "10px" }}
          >
            Already have an account?
            <span
              onClick={() => {
                history.push(`/login`);
              }}
              className={classes.link}
            >
              Log in
            </span>
          </p>

          <div className={classes.form}>
            {signedup ? (
              <>
                <Typography
                  variant="h5"
                  style={{ fontWeight: "bold", marginTop: "35px" }}
                >
                  Verify your Email
                </Typography>
                <p
                  style={{
                    fontWeight: "bold",
                    color: "#868786",
                    marginBottom: 0,
                  }}
                >
                  We just sent you an email with a code. Enter it to verify your
                  email id.
                </p>

                <p className={classes.question} style={{ marginTop: "20px" }}>
                  Didn't receive an email?
                  {counter === 0 || counter === 120 ? (
                    <span
                      onClick={resendOtp}
                      className={classes.link}
                      style={{ fontWeight: "bold" }}
                    >
                      Try Again
                    </span>
                  ) : (
                    <span
                      style={{
                        paddingLeft: "10px",
                        color: "#808080",
                        fontWeight: "bold",
                      }}
                    >
                      Try Again in {format(counter)}
                    </span>
                  )}
                </p>

                <Grid container spacing={2} style={{ marginTop: "25px" }}>
                  <Grid
                    item
                    xs={12}
                    style={isMobile ? { padding: "2px 8px" } : {}}
                  >
                    <p
                      style={{
                        color: "#868786",
                        marginBottom: "8px",
                        marginTop: 0,
                        fontWeight: "bold",
                      }}
                    >
                      ONE-TIME PASSWORD
                    </p>
                    <TextField
                      className={classes.textfeildBackground}
                      variant="outlined"
                      size={isMobile ? "small" : "normal"}
                      required
                      fullWidth
                      id="code"
                      type="number"
                      name="code"
                      onChange={(e) => setOtp(e.target.value)}
                      error={errorFields.otp}
                      helperText={
                        errorFields.otp ? "Please enter the OTP" : null
                      }
                      onKeyUp={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === "NumpadEnter"
                        ) {
                          submitForm();
                        }
                      }}
                      InputProps={{
                        classes: { notchedOutline: classes.noBorder },
                      }}
                    />
                  </Grid>
                </Grid>
                <Button
                  style={{
                    width: "240px",
                    height: "45px",
                    color: "#fff",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={submitForm}
                >
                  Verify
                </Button>
              </>
            ) : (
              <>
                {/* <p
                  style={{
                    fontWeight: "bold",
                    color: "#868786",
                    marginBottom: "16px",
                  }}  
                >
                  Enter your details below.
                </p> */}
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    style={isMobile ? { padding: "2px 8px" } : {}}
                  >
                    <p
                      className={classes.phone_p}
                      style={{ marginTop: "10px", paddingBottom: "4px" }}
                    >
                      Email ID
                    </p>
                    <ClickAwayListener
                      onClickAway={() => {
                        if (email) {
                          let re = /\S+@\S+\.\S+/;
                          if (re.test(email)) {
                            setErrorFields({
                              ...errorFields,
                              email: false,
                            });
                          } else {
                            setErrorFields({
                              ...errorFields,
                              email: true,
                            });
                          }
                        }
                      }}
                    >
                      <TextField
                        className={classes.textfeildBackground}
                        variant="outlined"
                        size={isMobile ? "small" : "normal"}
                        required
                        fullWidth
                        name="email"
                        id="email"
                        onChange={(e) => {
                          let val = e.target.value.replace(/\s/g, "");
                          setEmail(val);
                        }}
                        value={email}
                        error={errorFields.email}
                        helperText={errorFields.email ? "Invalid email" : null}
                        onKeyUp={(event) => {
                          if (
                            event.key === "Enter" ||
                            event.key === "NumpadEnter"
                          ) {
                            submitForm();
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <img src={UserIcon} />
                            </InputAdornment>
                          ),
                          inputProps: { maxLength: 50 },
                          classes: { notchedOutline: classes.noBorder },
                        }}
                      />
                    </ClickAwayListener>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={isMobile ? { padding: "2px 8px" } : {}}
                  >
                    <p
                      className={classes.phone_p}
                      style={{ paddingBottom: "4px" }}
                      // style={{ fontWeight: "bold", marginBottom: 0 }}
                    >
                      Password
                    </p>
                    {/* <p style={{ margin: 0, marginBottom: 10, color: "#868786" }}>
                    The password must include atleast 1 uppercase letter (A-Z),
                    1 lowercase letter (a-b) and 1 special character (@, $,
                    &...).
                  </p> */}
                    <TextField
                      className={classes.textfeildBackground}
                      variant="outlined"
                      size={isMobile ? "small" : "normal"}
                      required
                      fullWidth
                      name="password"
                      type="password"
                      id="password"
                      onChange={(e) => {
                        let val = e.target.value.replace(/\s/g, "");
                        if (val.length < 6 || val.length > 20) {
                          setErrorFields({
                            ...errorFields,
                            pass: true,
                            // repass: val !== repassword,
                          });
                        } else {
                          setErrorFields({
                            ...errorFields,
                            pass: false,
                            // repass: val !== repassword,
                          });
                        }
                        getPassword(val);
                      }}
                      value={password}
                      onPaste={(e) => {
                        e.preventDefault();
                      }}
                      InputProps={{
                        classes: { notchedOutline: classes.noBorder },
                        inputProps: { maxLength: 20 },
                      }}
                      error={errorFields.pass}
                      helperText={
                        errorFields.pass
                          ? "Password length should be between 6 to 20 characters"
                          : null
                      }
                      onKeyUp={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === "NumpadEnter"
                        ) {
                          submitForm();
                        }
                      }}
                    />
                    {/* {validPassword ? null : (
                    <p style={{ margin: 0, marginTop: 10, color: "red" }}>
                      Please make sure password meets all requirements
                    </p>
                  )} */}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={isMobile ? { padding: "2px 8px" } : {}}
                  >
                    <p
                      className={classes.phone_p}
                      style={{ paddingBottom: "4px" }}
                      // style={{ fontWeight: "bold" }}
                    >
                      Confirm Password
                    </p>
                    <TextField
                      className={classes.textfeildBackground}
                      variant="outlined"
                      size={isMobile ? "small" : "normal"}
                      required
                      fullWidth
                      name="verify"
                      type={showPassword ? "text" : "password"}
                      id="verify"
                      onChange={(e) => {
                        let val = e.target.value.replace(/\s/g, "");
                        if (val === password) {
                          setErrorFields({
                            ...errorFields,
                            repass: false,
                          });
                        } else {
                          setErrorFields({
                            ...errorFields,
                            repass: true,
                          });
                        }
                        setRepassword(val);
                      }}
                      value={repassword}
                      onPaste={(e) => {
                        e.preventDefault();
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {/* {showPassword ? <Visibility /> : <VisibilityOff />} */}
                            <img
                              src={PasswordEye}
                              aria-label="toggle password visibility"
                              // onMouseDown={() => setShowPassword(true)}
                              // onMouseUp={() => setShowPassword(false)}
                              onClick={() => {
                                setShowPassword(!showPassword);
                              }}
                              style={{ cursor: "pointer" }}
                            ></img>
                          </InputAdornment>
                        ),
                        inputProps: { maxLength: 20 },
                        classes: { notchedOutline: classes.noBorder },
                      }}
                      error={errorFields.repass}
                      helperText={
                        errorFields.repass ? "Passwords do not match" : null
                      }
                      onKeyUp={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === "NumpadEnter"
                        ) {
                          submitForm();
                        }
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={isMobile ? { padding: "2px 8px" } : {}}
                  >
                    <p
                      className={classes.phone_p}
                      // style={{ fontWeight: "bold" }}
                      onClick={() => setReferalBox(!referralBox)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingBottom: "4px",
                      }}
                    >
                      Referral or Promo code (optional)
                      <div style={{ height: "15px" }}>
                        <svg
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.32646 3.80867L11.6647 3.80867C11.9148 3.80867 12.0545 4.07273 11.8996 4.25301L7.73047 9.08738C7.61113 9.22576 7.38135 9.22576 7.26074 9.08738L3.0916 4.25301C2.93672 4.07273 3.07636 3.80867 3.32646 3.80867Z"
                            fill="#808080"
                          />
                        </svg>
                      </div>
                    </p>
                    <TextField
                      className={classes.textfeildBackground}
                      variant="outlined"
                      size={isMobile ? "small" : "normal"}
                      style={
                        referralBox ? { display: "block" } : { display: "none" }
                      }
                      required
                      fullWidth
                      name="referral"
                      type="text"
                      id="referral"
                      onChange={(e) => {
                        let val = e.target.value.replace(/[^a-zA-Z\d-]/, "");
                        setRefCode(val);
                      }}
                      InputProps={{
                        inputProps: { maxLength: 10 },
                        classes: { notchedOutline: classes.noBorder },
                      }}
                      value={refCode}
                      onKeyUp={(event) => {
                        if (
                          event.key === "Enter" ||
                          event.key === "NumpadEnter"
                        ) {
                          submitForm();
                        }
                      }}
                    />
                  </Grid>
                </Grid>
                {validForm ? null : (
                  <p style={{ margin: 0, marginTop: "26px", color: "red" }}>
                    Please make sure you have entered an email which is not
                    linked to any existing account
                  </p>
                )}
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "5px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    onChange={() => setTerms(!terms)}
                    checked={terms}
                    style={{
                      color: "#3AC4AB",
                    }}
                  />
                  <p>I agree to PocketBits Terms of Service.</p>
                  {/* <p>
                    By creating account, I agree to your Terms, Privacy, AML,
                    KYC Policy */}
                  {/* <Link
                    to={`/tandc`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={classes.policies}
                  >
                    terms
                  </Link>{" "}
                  and that you have read through our{" "}
                  <Link
                    to={`/privacy`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={classes.policies}
                  >
                    Privacy
                  </Link>
                  ,{" "}
                  <Link
                    to={`/aml`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={classes.policies}
                  >
                    AML & KYC Policy
                  </Link>
                  . */}
                  {/* </p> */}
                </div>

                <Button
                  style={{
                    width: "240px",
                    height: "45px",
                    color: "#fff",
                    fontWeight: "600",
                    // marginTop: "14px",
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={submitForm}
                >
                  CREATE YOUR ACCOUNT
                </Button>
              </>
            )}
          </div>
          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent style={{ textAlign: "center", marginTop: "20px" }}>
              {errorFields.failed ? (
                <CancelOutlinedIcon
                  style={{
                    fontSize: "60px",
                    color: "red",
                    marginBottom: "20px",
                  }}
                />
              ) : (
                <CheckCircleOutlineIcon
                  style={{
                    fontSize: "60px",
                    color: "#3AC4AB",
                    marginBottom: "20px",
                  }}
                />
              )}
              <DialogContentText id="alert-dialog-description">
                {errorFields.failed
                  ? "Registration failed! Please try again."
                  : "Account created successfully, please login to continue."}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                style={{
                  marginRight: "16px",
                  marginBottom: "16px",
                  color: "white",
                  fontWeight: "bold",
                }}
                onClick={handleDialogClose}
                color="primary"
                autoFocus
              >
                {errorFields.failed ? "Ok" : "Login"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <Backdrop className={classes.backdrop} open={loading}>
          {/* <CircularProgress color="primary" /> */}
          <img src={loaderGif} alt="loading..." />
        </Backdrop>

        <ReCAPTCHA sitekey={SITE_KEY_CAPTCHA} size="invisible" ref={reRef} />
      </Container>
      <div
        className={classes.root}
        component="main"
        maxWidth="xs"
        style={
          !isMobile
            ? {
                width: "65%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "65vh",
              }
            : {
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minHeight: "0vh",
                // alignItems: 'start',
                // marginTop: '10px'
              }
        }
      >
        <Swiper
          onInit={(swiper) => {
            ref.current = swiper;
          }}
          className="mySwiper"
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: true }}
          style={{ width: "65%" }}
        >
          <SwiperSlide>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <img
                style={
                  !isMobile
                    ? { width: "100%", height: "auto" }
                    : { width: "100%", height: "auto" }
                }
                src={
                  require("../../assets/signInPageSlideImages/Carousel1Login.png")
                    .default
                }
              ></img>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <img
                style={
                  !isMobile
                    ? { width: "100%", height: "auto" }
                    : { width: "100%", height: "auto" }
                }
                src={
                  require("../../assets/signInPageSlideImages/Carousel2Login.png")
                    .default
                }
              ></img>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        style={
          !isMobile
            ? {
                height: "65vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
              }
            : { display: "none" }
        }
      >
        {/* <img
          src-={require("../../assets/signInPageSlideImages/appSvg.svg").default}
          style={{
            height: "79px",
            width: "79px",
          }}
        ></img> */}
        <p style={{ marginBottom: "5px", fontSize: "12px" }}>Get it on</p>
        <img src={AppSVG}></img>
        <div
          style={{
            width: "90px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{ marginTop: "5px", fontSize: "12px" }}>Google play</p>
          {/* <img
            style={{ marginTop: "5px" }}
            width="16"
            height="16"
            src={GooglePlay}
          ></img> */}
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "start",
    height: "auto",
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      // maxWidth: "450px",
      // minWidth: "450px",
      // marginTop: "50px",
    },
    margin: "0",
  },
  rootCarousel: {
    width: "65%",
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    borderRadius: "5px",
    height: "100vh",
    backgroundColor:
      "radial-gradient(195.32% 195.32% at -29.61% 64.11%, #262D41 0%, #131518 100%);",
    padding: "0 35px",
  },
  mobileGrid: {
    padding: "4px",
  },
  mainContainerMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "70px",
  },
  paper: {
    // [theme.breakpoints.up("md")]: {
    //   marginTop: theme.spacing(15),
    // },
    // [theme.breakpoints.down("sm")]: {
    //   marginTop: theme.spacing(5),
    //   marginLeft: theme.spacing(2),
    //   marginRight: theme.spacing(2),
    // },
    display: "flex",
    flexDirection: "column",
  },
  title: {
    // fontSize:"2.5rem",
    alignItems: "left",
    fontWeight: 900,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    alignItems: "center",
  },
  phone_p: {
    color: "#868786",
    marginTop: "0px",
  },
  submit: {
    margin: !isMobile ? theme.spacing(3, 0, 2) : theme.spacing(1, 0, 0),
  },
  link: {
    fontWeight: "500",
    color: "#3AC4AB",
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  question: {
    // fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  policies: {
    color: "#4fa9ff",
    textDecoration: "underline",
  },
  noBorder: {
    border: "none",
  },
  textfeildBackground: {
    backgroundColor: "#222830",
    borderRadius: "5px",
    "& #email-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #verify-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #code-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #referral-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #password-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
  },
}));
